import {
	CREATOR_INTEREST_STATUS_META,
	CREATOR_INTEREST_STATUS_OPTIONS,
	CreatorInterestStatus,
} from "@/shared/types/campaign";
export { CREATOR_INTEREST_STATUS_META, CREATOR_INTEREST_STATUS_OPTIONS };

export const normalizeCreatorInterestStatus = (
	value: CreatorInterestStatus | boolean | string | null | undefined,
): CreatorInterestStatus | undefined => {
	if (value === null || value === undefined || value === "") {
		return undefined;
	}

	if (typeof value === "boolean") {
		return value ? "interested" : "not-interested";
	}

	const normalized = value.toLowerCase().replace(/[\s_]+/g, "-");
	if (normalized === "outreach") return "outreached";
	if (normalized === "outreached") return "outreached";
	if (normalized === "negotiating") return "negotiating";
	if (normalized === "interested") return "interested";
	if (normalized === "not-interested") return "not-interested";

	return undefined;
};

export const getCreatorInterestStatusLabel = (
	status: CreatorInterestStatus | boolean | string | null | undefined,
): string => {
	const normalized = normalizeCreatorInterestStatus(status);
	return normalized ? CREATOR_INTEREST_STATUS_META[normalized].label : "—";
};
